module.exports = __webpack_public_path__ + "img/gh-12205-6.prt.d9703b3c.jpg";